import { useDispatch } from "react-redux";
import styles from "./imageUploader.module.css";
import { uploadTournamentImage } from "../../../features/images/tournamentImages/tournamentImagesSlice";
import TextWrapper from "../../textWrapper/TextWrapper";
import { uploadRegionImage } from "../../../features/images/regionImages/regionImagesSlice";
import { uploadUserImage } from "../../../features/images/userImages/userImagesSlice";
import { uploadSquadImage } from "../../../features/images/squadImages/squadImagesSlice";

const ImageUploader = ({ tag, onFileSelect, label, error, inputId }) => {
  const dispatch = useDispatch();
  const id = inputId || "file-upload";

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (onFileSelect) {
      onFileSelect(file);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);
    formData.append("tag", tag);
    formData.append("name", file.name);

    if (tag === "tournament") {
      dispatch(uploadTournamentImage(formData));
    }

    if (tag === "region") {
      dispatch(uploadRegionImage(formData));
    }

    if (tag === "user") {
      dispatch(uploadUserImage(formData));
    }

    if (tag === "squad") {
      dispatch(uploadSquadImage(formData));
    }
  };

  return (
    <div className={styles.inputContainer}>
      <label className={styles.fileUploaderLabel} htmlFor={id}>
        <TextWrapper textStyle="textMid">{label || "رفع صوره"}</TextWrapper>
      </label>
      <input
        id={id}
        type="file"
        accept="image/*"
        onChange={(e) => handleFileChange(e)}
        className={styles.fileInput}
      />
      {error && <span className={styles.errorText}>{error}</span>}
    </div>
  );
};

export default ImageUploader;
